import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { LocalStorageService } from '@ups/xplat/core';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { ToolTrackerActions } from './tool-tracker.action';
import { ContainerService } from '../services/container-service';

@Injectable()
export class ToolTrackerEffects {
  loadContainerOData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToolTrackerActions.loadContainersOData),
      switchMap(({ odataQuery }) =>
        this.containerService.getContainerOData(odataQuery, true).pipe(
          mergeMap((results) => [
            ToolTrackerActions.loadContainersSuccess({
              containers: results.value,
              count: Number(results['@odata.count'] ?? 0),
            }),
          ])
        )
      ),
      catchError((x) => of(ToolTrackerActions.loadContainersError(x)))
    )
  );

  //logActions$ = createEffect(() => this.actions$.pipe(tap((x) => console.log('ACTION DISPATCHED:', x.type, x))), { dispatch: false });

  constructor(
    private actions$: Actions,
    private storageService: LocalStorageService,
    private containerService: ContainerService
  ) {}

  /* add implements OnInitEffects if using OnInitEffects
  ngrxOnInitEffects(): Action {
    console.log('ON INIT Warehouse Mgmt');
    return ToolTrackersActions.initializeToolTrackerSheet({
      selectedContainer: this.storageService.getItem<ContainerDTO>(selectedContainerKey),
    });
  }
  */
}
